<template>
  <div class="login__form">
    <v-layout>
      <v-flex xs12>
        <v-card class="pa-0">
          <v-alert
            v-model="error"
            class="ma-0"
            dismissible
            type="error"
          >
            {{errorMsg}}
          </v-alert>
          <div class="px-4 py-4">
            <v-card-title primary-title class="px-0 pt-0">
              <div>
                <div class="headline">Przypomnij hasło</div>
                <span class="grey--text">
                  Podaj PIN oraz adres e-mail na który mamy wysłać nowe hasło
                </span>
              </div>
            </v-card-title>
            <form class="pb-4">
              <div class="pb-2">
                <v-text-field
                  v-model.trim="formData.pin"
                  label="Kod PIN"
                  :error-messages="errors.collect('pin')"
                  :type="'password'"
                  v-validate="'required|max:10|min:6|alpha_num'"
                  data-vv-name="pin"
                  data-vv-as="pin"
                  required
                ></v-text-field>
              </div>
              <div class="pb-2">
                <v-text-field
                  v-model.trim="formData.email"
                  label="Adres e-mail"
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  data-vv-name="email"
                  data-vv-as="adres e-mail"
                  required
                ></v-text-field>
              </div>
            </form>
          <v-card-actions class="px-0">
            <v-layout align-center>
              <v-flex xs6>
                <router-link class="primary--text" to="/login">
                  Logowanie
                </router-link>
              </v-flex>
              <v-flex xs6 class="text-xs-right">
                <ServerErrors />
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :loading="busy"
                  :disabled="busy"
                  @click="resetPasswordInit"
                >Wyślij</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
          <ServerErrors :errorsItems="serverErrors" />
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getError } from '../../helpers/helpers';
import { resetPasswordMail } from '../../repository/auth';
import ServerErrors from '../common/Errors/ServerErrors.vue';

export default {
  name: 'recive-password-form',
  data: () => ({
    errorMsg: null,
    error: null,
    serverErrors: [],
    busy: false,
    formData: {
      pin: null,
      email: null,
    },
  }),
  components: {
    ServerErrors,
  },
  methods: {
    ...mapActions('app', [
      'setSnackBar',
    ]),
    clearData() {
      this.$validator.reset();
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
      this.busy = false;
      this.formData = {
        pin: null,
        email: null,
      };
    },
    resetPasswordInit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.resetPassword();
        }
      });
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    async resetPassword() {
      this.busy = true;
      try {
        const resetRes = await resetPasswordMail(this.formData);
        this.setSnackBar(resetRes.data.status.msg);
        this.busy = false;
        this.clearData();
      } catch (e) {
        if (e) {
          this.getError(e);
        }
      }
    },
  },
};
</script>
